<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template> 

<script>
import autofit from 'autofit.js';
export default {
  name: 'app',
  mounted() {
		autofit.init({
			dh: 1080,
			dw: 1920,
			el: '#app',
			resize: true
		});
	},
  components: {
  }
}
</script>

<style>

</style>
